import React from "react"
import request from "../util/request"
import SearchBar from "../legacy_components/SearchBar"
import webify from "../util/webify"
import { format, parseISO } from "date-fns"

export default class AdminTripSearch extends React.Component {
  performLookup = (query) => {
    const url = `/api/admin/trips/search?q=${query}`
    return request("GET", url)
  }

  renderSearchResultRow = (r, _resetSearchState) => {
    return (
      <a
        class="grid grid-flow-col hover:no-underline hover:bg-gray-100 px-2 py-2"
        href={`/admin/trips/${r.id}`}
      >
        <div>
          <div className="font-bold text-left">
            #{r.id}: {r.public_trip_name}
          </div>
          <div className="text-gray-600 text-left">
            {this.dates(r)} | {r.destination}
          </div>
        </div>
        <div className="font-bold text-right">{this.renderStatus(r)}</div>
      </a>
    )
  }

  renderStatus(r) {
    let className = null

    if (r.status == "active") {
      className = "text-green-700"
    } else if (r.status == "archived") {
      className = "text-orange-400"
    } else if (r.status == "cancelled") {
      className = "text-gray-500"
    }
    

    return <div className={className}> {this.capitalize(r.status)} </div>
  }

  dates(t) {
    const start = format(parseISO(t.start_date), "dd MMM yyyy")
    const end = format(parseISO(t.end_date), "dd MMM yyyy")
    return `${start} — ${end}`
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  render() {
    return (
      <div className="search-bar">
        <SearchBar
          renderSearchResultRow={this.renderSearchResultRow}
          performLookup={this.performLookup}
          placeholder="Search all trips..."
        />
      </div>
    )
  }
}

webify("admin-trip-search", AdminTripSearch)
